import React, { memo, useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { message, Modal } from 'antd';

import bytes from 'bytes';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { imgLocalUrl, logNative } from '../../utils/utils';
import { PCStoreJsBridge } from '../../nativeapi';
import { CONTEXT } from '../../config';

import defaultImg from '../../static/default.svg';
import styles from './UninstLineCard.module.less';

import { logPostInfo, logging } from '../../actions/log';
import { setMenuSpot, setDetailCommentVisible } from '../../actions/layout';
import { getLocalSoft, removeUninstall } from '../../actions/native';
import { addUninstall, cancelUninstall, removeTempResidual } from '../../actions/uninstall';
import { mySoftKeys } from '../../constants/storageKeys';
import ResidualSoft from './ResidualSoft';
import Rate from '../../components/Rate/Rate';
import Dialog from '../../components/Dialog/Dialog';
import DEFAULT from '../../static/wp_wj.svg';
import native from '../../reducers/native';
import loading from '../../static/loading.gif';
import fingerHeart from '../../static/finger_heart.gif';
import Config from './Uninstall.config';
import ButtonUninstall0 from '../../components/Button/ButtonUninstall0/ButtonUninstall0';
import ButtonUninstall1 from '../../components/Button/ButtonUninstall1/ButtonUninstall1';
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUninstallSoft = createSelector(
  state => state.native,
  native => native.uninstallSoft,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUnistallFinishSoft = createSelector(
  state => state.native,
  native => native.uninstallFinishSoft,
);

// 处理卸载失败的情况
const selectConstrain = createSelector(
  state => state.uninstall,
  uninstall => uninstall.setConstrain,
);

export default memo(props => {
  const { soft, logInfo, tempResidualList, softInfo = {} } = props;
  const dispatch = useDispatch();
  const [tempResidualInfo, setTempResidualInfo] = useState(null);
  const logInfoData = useSelector(selectLogInfo);
  const installedSoft = useSelector(selectInstalledSoft);
  const uninstallSoftList = useSelector(selectUninstallSoft);

  const [uninstallSoft, setUninstallSoft] = useState(null);
  const [isShowSpot, setIsShowSpot] = useState(false);
  const [visible, setVisible] = useState(false);

  const [uninstallSoftInfo, setUninstallSoftInfo] = useState(null);
  const [constraintTag, setConstraintTag] = useState(false); // 强制卸载弹窗开启标识
  const [startConstrain, setStartConstrain] = useState(false); // 开始强制卸载的标识
  const finishSoft = useSelector(selectUnistallFinishSoft); // 区别当前软件是否是强力卸载好了的软件
  const [uninstallPath, setUninstallPath] = useState(null); //   强力卸载文件路径
  const constrain = useSelector(selectConstrain); // 处理强力卸载失败
  const [userGrade, setUserGrade] = useState(0);

  const addDesktopEl = useRef(null);
  const [uninstallTag, setUninstallTag] = useState(false);
  const [uninstallType, setUninstallType] = useState(1);

  // 后期修补 卸载根目录的bug
  const [isCantUninstall, setIsCantUninstall] = useState(true);

  // 强力卸载失败
  useEffect(() => {
    if (startConstrain) {
      let guid = JSON.parse(constrain.softGUID).guid;
      if (soft.softGUID === guid) {
        setStartConstrain(false);
      }
    }
  }, [constrain]);

  /**
   * 设置初始化用户评分
   */
  useEffect(() => {
    if (
      soft &&
      (soft.SoftID || soft.softID) &&
      softInfo &&
      softInfo[soft.SoftID] &&
      softInfo[soft.SoftID].userGrade
    ) {
      setUserGrade(softInfo[soft.SoftID].userGrade);
    }
    if (soft && soft.androidType === '1') {
      setUserGrade(soft.userGrade);
    }
  }, [soft, softInfo]);

  useEffect(() => {
    message.config({ top: 318, duration: 2.8 });
    const found = uninstallSoftList.find(
      v =>
        (soft.androidType !== '1' && v.softGUID === soft.softGUID) ||
        (soft.androidType === '1' && v.packageName === soft.packageName),
    );
    setUninstallSoft(found || null);
  }, [uninstallSoftList]);

  useEffect(() => {
    const data =
      tempResidualList &&
      tempResidualList.find(item => {
        return item.softGUID === soft.softGUID;
        // && item.isx64 === soft.isx64;
      });
    setTempResidualInfo(data);
  }, [tempResidualList, soft]);
  // 展示设置小红点
  useEffect(() => {
    const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT) || '';
    if (soft && soft.packageName) {
      setIsShowSpot(spotSoftStr.indexOf(soft.packageName) > -1);
    }
  }, [installedSoft, soft]);

  const handleOpen = useCallback(
    softInfo => {
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID,
        softName: softInfo.softName,
        softType: 'o',
        url: softInfo.downLoadUrl || softInfo.downloadUrl,
        type: 'o',
      };
      // 按钮点击打桩
      logParam2.type = 'o';
      if (softInfo.androidType === '1') {
        logParam2.softType = '1';
        logParam2.softid = softInfo.packageName;
        logParam2.versionCode = softInfo.versionCode;
        logParam2.softName = softInfo.softName;
        // 首先判断模拟器是否已经安装。
        PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
          if (SIMInstalled) {
            PCStoreJsBridge.openAndroidSoft({ ...softInfo, logInfo: logParam2 }).then(isOpen => {
              if (isOpen !== true) {
                message.info('软件运行失败！');
                dispatch(getLocalSoft());
              }
            });
          } else {
            // 当不存在模拟器重新获取一次本地列表改变按钮的状态。
            dispatch(getLocalSoft());
          }
        });

        // 展示取消小红点
        // 是否为第一次打开，取消小红点
        logParam2.type = '0';
        const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const spotSoft = spotSoftStr && spotSoftStr.split(',');
        if (spotSoft && spotSoft.indexOf(softInfo.packageName) > -1) {
          spotSoft.splice(spotSoft.indexOf(softInfo.packageName), 1);
          localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSoft.join(','));
          setIsShowSpot(false);
          logParam2.type = '1';
        }

        // 更新菜单上的小红点
        const spotSoftStrNew = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const installedSpotSoft = installedSoft.find(
          softItem =>
            softItem.androidType === '1' &&
            spotSoftStrNew &&
            spotSoftStrNew.indexOf(softItem.packageName) > -1,
        );
        dispatch(setMenuSpot(installedSpotSoft && installedSpotSoft.packageName));
      } else {
        logParam2.softType = '0';
        logParam2.softid = softInfo.SoftID;
        logParam2.softName = softInfo.displayName;
        PCStoreJsBridge.openSoft(softInfo).then(isOpen => {
          if (isOpen !== true) {
            message.info('软件运行失败！');
            dispatch(getLocalSoft());
          }
        });
      }
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Open',
          label: '',
          param2: logParam2,
          param3: softInfo.bizInfo || '{}',
        }),
      );
    },
    [dispatch, logInfoData],
  );

  const handleUninstall = useCallback(
    (softInfo, uninstallType, type = 1) => {
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID || softInfo.SoftID || '',
        softname: softInfo.softGUID,
        softType: softInfo.androidType === '1' ? '1' : '0',
      };
      if (softInfo.androidType === '1') {
        logParam2.softid = softInfo.packageName;
      }
      // 卸载页面-继续卸载
      if (uninstallType === 'modal') {
        dispatch(
          logging({
            category: 'C',
            action: 'Uninstall_Protect_Continue',
            label: '',
            param2: logParam2,
          }),
        );
      }
      // 关闭弹窗
      setVisible(false);
      // 添加卸载任务，开始卸载软件
      logNative(
        `开始调用卸载软件，添加卸载任务, ${JSON.stringify(logParam2)}`,
        softInfo,
        true,
        true,
      );
      dispatch(addUninstall(softInfo));
      if (softInfo.androidType === '1') {
        PCStoreJsBridge.uninstallAndroidSoft(softInfo)
          .then(succ => {
            if (succ !== 'true') {
              dispatch(cancelUninstall(softInfo));
            }
          })
          .catch(err => {});
      } else {
        PCStoreJsBridge.uninstallSoft({ ...softInfo, mode: 1, type });
      }
    },
    [dispatch, logInfoData],
  );

  const handleUnInstallOper = useCallback(softInfo => {
    const logParam2 = {
      source: 'Mysofts',
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: softInfo.softID || softInfo.SoftID || '',
      softname: softInfo.softGUID,
      softType: softInfo.androidType === '1' ? '1' : '0',
    };
    if (softInfo.androidType === '1') {
      logParam2.softid = softInfo.packageName;
    }
    // 卸载页面-点击创建快捷方式-打桩

    if (!softInfo.title) {
      handleUninstall(softInfo);
      return;
    }
    setUninstallSoftInfo(softInfo);
    setVisible(true);
    // 打开卸载保护弹窗打桩
    dispatch(
      logging({
        category: 'P',
        action: 'Uninstall_Protect',
        label: '',
        param2: logParam2,
      }),
    );
  });

  // 点击卸载后先进行判断是否是需要强制卸载
  const constraintJudge = (softInfo, tag, uType) => {
    if (tag === 1) {
      dispatch(
        logging({
          category: 'C',
          action: 'T_Cleaner',
          label: '',
          param2: {
            guid: softInfo.softGUID,
            softid: softInfo.softID ?? softInfo.SoftID ?? '',
            source: 'Mysofts',
            source_p: logInfoData.source_p,
          },
        }),
      );
    }

    if (isCantUninstall) {
      PCStoreJsBridge.judgeUninstallSoft({
        isuwp: softInfo.isuwp,
        isx64: softInfo.isx64,
        softGUID: softInfo.softGUID,
      }).then(res => {
        if (res.mode === 1) {
          handleUnInstallOper(softInfo);
        } else if (res.mode === 2) {
          setUninstallPath(res.installpath);
          setConstraintTag(true);
          setUninstallType(uType);
          let logParam2 = {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softInfo.softID || softInfo.SoftID || '',
            type: uType,
          };
          dispatch(
            logging({
              category: 'P',
              action: 'Uninstall_Fail',
              label: '',
              param2: logParam2,
            }),
          );
        }
      });
    } else {
      setUninstallTag(true);
      dispatch(
        logging({
          category: 'P',
          action: 'Root_Uninstall',
          label: '',
          param2: {
            softid: softInfo.softID ?? softInfo.SoftID ?? '',
            guid: softInfo.softGUID,
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  };

  // 开始强力卸载
  const startConstrainUninstall = soft => {
    setStartConstrain(true);
    setConstraintTag(false);
    dispatch(
      logging({
        category: 'C',
        action: 'Uninstall_Fail_Force',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft.softID || soft.SoftID || '',
          softguid: soft.softGUID,
          type: uninstallType,
        },
      }),
    );
    PCStoreJsBridge.uninstallSoft({
      isuwp: soft.isuwp,
      softGUID: soft.softGUID,
      isx64: soft.isx64,
      mode: 2,
      type: uninstallType,
    });
  };

  const handleCancelModal = useCallback(
    uninstallType => {
      setVisible(false);
      setUninstallType(1);
      if (uninstallType === 'modal') {
        // 通过弹窗里面暂不卸载 关闭卸载保护弹窗
        dispatch(
          logging({
            category: 'C',
            action: 'Uninstall_Protect_Cancel',
            label: '',
            param2: {
              source: 'Mysofts',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: soft.softID || soft.SoftID || '',
              softname: soft.softGUID,
              softType: soft.androidType === '1' ? '1' : '0',
            },
          }),
        );
        return;
      }
      // 直接关闭卸载保护弹窗
      dispatch(
        logging({
          category: 'C',
          action: 'Uninstall_Protect_Close',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.softID || soft.SoftID || '',
            softname: soft.softGUID,
            softType: soft.androidType === '1' ? '1' : '0',
          },
        }),
      );
    },
    [logInfoData],
  );

  const handleSoftCard = useCallback(() => {
    // const source = logInfo ? logInfo.source : 'Mysofts';
    dispatch(
      logPostInfo({
        source_p: 'Mysofts',
        source_pp: logInfoData.source_p,
      }),
    );
  }, [dispatch]);

  /**
   * 添加临时逻辑判断, 后期修补 卸载根目录的bug
   */
  const judgeChildPath = pathStr => {
    if (pathStr) {
      let pathList = pathStr.split(/\\/);
      let startIndex = pathList.findIndex(item => item === '..');
      while (startIndex > -1) {
        pathList.splice(startIndex - 1, 2);
        startIndex = pathList.findIndex(item => item === '..');
      }
      pathList = pathList.filter(item => item && !/\.exe$/.test(item));
      return pathList.length > 1;
    }
    return false;
    // if (pathStr) {
    //   const instArr = pathStr.split('\\');
    //   const backArr = instArr.filter(item => item === '..');

    //   if (instArr.length === 1) {
    //     return false;
    //   }
    //   if (instArr.length === 2 && (instArr[1].indexOf('.exe') > -1 || instArr[1] === '')) {
    //     return false;
    //   }
    //   if (instArr.length === 3 && (instArr[1] === '..' || instArr[2].indexOf('.exe') > -1)) {
    //     return false;
    //   }
    //   if (instArr.length > 3 && instArr.length - 3 < backArr.length * 2) {
    //     return false;
    //   }
    //   return true;
    // }
    // return false;
  };

  useEffect(() => {
    if (!soft.installString && !soft.MainExePath) {
      return;
    }
    if (!judgeChildPath(soft.installString, soft) && !judgeChildPath(soft.MainExePath, soft)) {
      setIsCantUninstall(false);
      logNative(`卸载目录不常规，疲敝这个软件 ${soft}`, {}, true, true);
    }
  }, [soft]);

  const handleRate = useCallback(
    (e, bizIdentity) => {
      const handleStar = parseInt(e.target.getAttribute('star'));
      const softs = {
        ...soft,
        ...(softInfo[bizIdentity] || {}),
      };
      dispatch(
        setDetailCommentVisible({
          visible: true,
          soft: softs,
          handleStar,
          successFunc: updateList,
          time: +new Date(),
          requestInfo: {
            bizIdentity,
            tagCode: softs?.androidType === '1' ? softs?.classID : softs?.lenovoClassId,
            type: 1,
          },
          commentTargetInfo: {
            targetId: bizIdentity,
            targetName: softs?.softName,
            targetCategoryCode: [
              softs?.androidType === '1' ? softs?.classID : softs?.lenovoClassId,
            ],
            version: softs?.version,
          },
        }),
      );
    },
    [dispatch, soft, softInfo],
  );

  const updateList = useCallback(() => {
    dispatch(getLocalSoft());
    dispatch(setDetailCommentVisible({}));
  }, [dispatch]);

  if (
    tempResidualInfo &&
    !judgeChildPath(soft.installString) &&
    !judgeChildPath(soft.MainExePath)
  ) {
    return null;
  }

  // 强制卸载打开文件夹对应路径
  const openSoftFolder = () => {
    PCStoreJsBridge.openFolder(uninstallPath);
    dispatch(
      logging({
        category: 'C',
        action: 'Uninstall_Fail_Directory',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft.softID || soft.SoftID || '',
          softguid: soft.softGUID,
          type: uninstallType,
        },
      }),
    );
  };

  // 关闭强力卸载的弹出框
  const handleCloseConstrain = () => {
    setConstraintTag(false);

    dispatch(
      logging({
        category: 'C',
        action: 'Uninstall_Fail_Cancel',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft.softID || soft.SoftID || '',
          softguid: soft.softGUID,
          type: uninstallType,
        },
      }),
    );
  };
  return (
    <>
      {soft.androidType === '1' ? (
        <div
          data-softtag={`${soft.softGUID}-${soft.isx64}`}
          className={!uninstallSoft ? styles.line_soft : styles.line_soft_disable}
        >
          <div className="soft_logo">
            {soft.packageName ? (
              <Link
                className="soft_info_name"
                to={{
                  pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode ||
                    0}/${soft.bizInfo || '{}'}`,
                }}
                onClick={() => {
                  handleSoftCard(soft);
                }}
              >
                <img src={soft.logoFile} alt="" />
              </Link>
            ) : (
              <img src={soft.logoFile} alt="" />
            )}
            {/* <img src={soft.logoFile} alt="" /> */}
            <div className="icon alogo" />
            {false && (
              <div className="soft_add_desktop" ref={addDesktopEl}>
                创建桌面图标
              </div>
            )}
          </div>
          <div className="soft_info">
            {soft.packageName ? (
              <Link
                className="soft_info_name"
                to={{
                  pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode ||
                    0}/${soft.bizInfo || '{}'}`,
                }}
                onClick={() => {
                  handleSoftCard(soft);
                }}
              >
                {soft.softName}
              </Link>
            ) : (
              <div className="soft_info_name">{soft.softName}</div>
            )}
            <div className="soft_info_desc">{soft.publisher}</div>
          </div>
          <div className="soft_time">
            {!soft.installdate && '未知'}
            {soft.installdate && dayjs(soft.installdate).format('YYYY-MM-DD')}
          </div>
          <div className="soft_size">
            {bytes(Number(soft.estimateSize), { unitSeparator: ' ' })}
          </div>
          <div
            className={soft && soft.packageName ? 'soft_score' : 'soft_score_'}
            onClick={e => {
              soft && soft.packageName && handleRate(e, soft.packageName);
            }}
          >
            {soft && soft.packageName && (
              <>
                <div
                  className="soft_score_text"
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  {Number(userGrade) === 0 ? '暂未评分' : '我的评分'}
                </div>
                <Rate
                  score={Number(userGrade).toFixed(1)}
                  rateInfo={{ isNeedClick: true }}
                  primary={true}
                  soft={true}
                />
              </>
            )}
            {/* {soft && soft.packageName && (
              <Rate score={Number(soft.userGrade).toFixed(1)} rateInfo={{ isNeedClick: true }} />
            )} */}
          </div>
          <div className="soft_operation">
            <div
              className="uninstall_btn"
              onClick={() => {
                if (!uninstallSoft) {
                  handleUnInstallOper(soft);
                }
              }}
            >
              {!uninstallSoft ? '卸载' : '卸载中'}
            </div>
            {/* <div
              className="open_btn"
              onClick={() => {
                if (!uninstallSoft) {
                  handleOpen(soft);
                }
              }}
            >
              <span>打开</span>
              {isShowSpot && <span className="open_btn_spot" />}
            </div> */}
            <ButtonUninstall1
              soft={soft}
              info={{ className: 'open_btn', text: '打开', className_busing: 'open_btn_busing' }}
              logInfo={{ source: 'Mysofts' }}
              isShowSpot={isShowSpot}
              handleIsShowSpot={data => setIsShowSpot(data)}
              handleUninstall={() => constraintJudge(soft, 0, 1)}
            />
          </div>
        </div>
      ) : (
        <div
          data-softtag={`${soft.softGUID}-${soft.isx64}`}
          className={
            !uninstallSoft || tempResidualInfo ? styles.line_soft : styles.line_soft_disable
          }
        >
          {!tempResidualInfo && (
            <>
              <div className="soft_logo">
                {soft.SoftID ? (
                  <Link
                    className="soft_info_name"
                    to={`${CONTEXT}/detail/soft/${soft.SoftID}/${soft.bizInfo || '{}'}`}
                    onClick={() => {
                      handleSoftCard(soft);
                    }}
                  >
                    <img
                      src={
                        soft.logoFile ||
                        (soft.displayIcon ? imgLocalUrl(soft.displayIcon) : defaultImg)
                      }
                      alt=""
                    />
                  </Link>
                ) : (
                  <img
                    src={
                      soft.logoFile ||
                      (soft.displayIcon ? imgLocalUrl(soft.displayIcon) : defaultImg)
                    }
                    alt=""
                  />
                )}
                {/* <img
                  src={
                    soft.logoFile || (soft.displayIcon ? imgLocalUrl(soft.displayIcon) : defaultImg)
                  }
                  alt=""
                /> */}
              </div>

              <div className="soft_info">
                {soft.SoftID ? (
                  <Link
                    className="soft_info_name"
                    to={`${CONTEXT}/detail/soft/${soft.SoftID}/${soft.bizInfo || '{}'}`}
                    onClick={() => {
                      handleSoftCard(soft);
                    }}
                  >
                    <div className="soft_info_name" title={soft.displayName}>
                      {soft.displayName}
                    </div>
                  </Link>
                ) : (
                  <div className="soft_info_name_" title={soft.displayName}>
                    {soft.displayName}
                  </div>
                )}
                <div className="soft_info_desc" title={soft.publisher}>
                  {soft.publisher}
                </div>
              </div>

              {startConstrain && (
                <>
                  {soft.softGUID === finishSoft.softGUID ? (
                    <div className={styles.constrain_finish}>
                      <img src={fingerHeart} />
                      卸载成功
                    </div>
                  ) : (
                    <div className={styles.constrain_uninstall}>
                      <img src={loading} />
                      正在进行应用卸载，请耐心等待...
                    </div>
                  )}
                </>
              )}
              {!startConstrain && (
                <>
                  <div className="soft_time">{dayjs(soft.installdate).format('YYYY-MM-DD')}</div>
                  <div className="soft_size">
                    {soft.estimateSize !== '0'
                      ? bytes(Number(soft.estimateSize), { unitSeparator: ' ' })
                      : '未知'}
                  </div>
                  <div
                    className={soft && soft.SoftID ? 'soft_score' : 'soft_score_'}
                    onClick={e => {
                      soft && soft.SoftID && handleRate(e, soft.SoftID);
                    }}
                  >
                    {soft && soft.SoftID && (
                      <>
                        <div
                          className="soft_score_text"
                          onClick={e => {
                            e.stopPropagation();
                          }}
                        >
                          {Number(userGrade) === 0 ? '暂未评分' : '我的评分'}
                        </div>
                        <Rate
                          score={Number(userGrade).toFixed(1)}
                          rateInfo={{ isNeedClick: true }}
                          primary={true}
                          soft={true}
                        />
                      </>
                    )}
                  </div>
                  <div className="soft_operation">
                    {/* {isCantUninstall ? ( */}
                    <div
                      className="uninstall_btn"
                      onClick={() => {
                        if (!uninstallSoft) {
                          // handleUnInstallOper(soft);
                          constraintJudge(soft, 1, 1);
                        }
                      }}
                    >
                      {!uninstallSoft ? '卸载' : '卸载中'}
                    </div>
                    {/* ) : (
                    //   <div className="uninstall_btn_disable">卸载</div>
                     )/*/}
                    {soft.MainExePath ? (
                      // <div
                      //   className="open_btn"
                      //   onClick={() => {
                      //     if (!uninstallSoft) {
                      //       handleOpen(soft);
                      //     }
                      //   }}
                      // >
                      //   打开
                      // </div>
                      <ButtonUninstall0
                        soft={soft}
                        info={{
                          className: 'open_btn',
                          text: '打开',
                          className_busing: 'open_btn_busing',
                          disable: !(!uninstallSoft || tempResidualInfo),
                        }}
                        logInfo={{ source: 'Mysofts' }}
                        handleUninstall={() => constraintJudge(soft, 0, 2)}
                      />
                    ) : (
                      <div className="open_btn_disable">打开</div>
                    )}
                  </div>
                </>
              )}
            </>
          )}
          {tempResidualInfo && (
            <ResidualSoft
              residualInfo={{
                ...tempResidualInfo,
                logoFile:
                  (softInfo[soft.SoftID || soft.softid] &&
                    softInfo[soft.SoftID || soft.softid].logoFile) ||
                  tempResidualInfo.logoFile,
              }}
              soft={{
                ...tempResidualInfo,
                ...soft,
                logoFile:
                  (softInfo[soft.SoftID || soft.softid] &&
                    softInfo[soft.SoftID || soft.softid].logoFile) ||
                  tempResidualInfo.logoFile,
              }}
            />
          )}
        </div>
      )}
      {visible && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          handleClose={handleCancelModal}
          title="温馨提示"
        >
          <div className={styles.modal_content}>{uninstallSoftInfo && uninstallSoftInfo.title}</div>
          <div className={styles.modal_button}>
            <div
              className={classNames(styles.button, styles.install)}
              onClick={() => {
                handleUninstall(uninstallSoftInfo, 'modal');
              }}
            >
              继续卸载
            </div>
            <div
              className={classNames(styles.button, styles.uninstall)}
              onClick={() => {
                handleCancelModal('modal');
              }}
            >
              暂不卸载
            </div>
          </div>
        </Dialog>
      )}

      {constraintTag && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.force_delete}
          handleClose={() => setConstraintTag(false)}
          title=""
        >
          <div className={styles.title}>该应用无法正常卸载，建议强制删除</div>
          {uninstallPath ? (
            <div className={styles.message}>
              强制删除会将该应用目录下所有文件删除，您可以 查看
              <span className={styles.open} onClick={openSoftFolder}>
                <img src={DEFAULT} /> 安装目录
              </span>
              是否存在重要文件
            </div>
          ) : (
            <div className={styles.message}>
              强制删除时会删除软件相关文件，请确认是否进行删除操作
            </div>
          )}
          <div className={styles.btn_operation}>
            <div className={styles.btn} onClick={handleCloseConstrain}>
              取消
            </div>
            <div className={styles.btn_create} onClick={() => startConstrainUninstall(soft)}>
              强制删除
            </div>
          </div>
        </Dialog>
      )}
      {uninstallTag && (
        <Dialog
          maskStyle={styles.maskr}
          containerStyle={styles.root_dialog}
          handleClose={() => setUninstallTag(false)}
          title="温馨提示"
        >
          <div className={styles.message}>该应用安装在根目录下，需要您在控制面板中进行卸载。</div>
          <div className={styles.btn_operation}>
            <div className={styles.btn_create} onClick={() => setUninstallTag(false)}>
              好的
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
});
